<template>
  <!-- The password step's email: initial, address, and "Change" back to the email step. -->
  <button type="button" class="si-chip" data-test="email-chip" :aria-label="t('auth.identity.changeEmail', { email })" @click="$emit('change')">
    <span class="si-chip__initial" aria-hidden="true">{{ initial }}</span>
    <span class="si-chip__email">{{ email }}</span>
    <span class="si-chip__change" aria-hidden="true">· {{ t("auth.identity.change") }}</span>
  </button>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "EmailChip",
  props: {
    email: { type: String, required: true },
  },
  emits: ["change"],
  setup(props) {
    const { t } = useI18n();
    const initial = computed(() => props.email.trim().charAt(0).toUpperCase() || "?");
    return { t, initial };
  },
});
</script>

<style scoped>
.si-chip {
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  min-height: 44px;
  padding: 6px 12px 6px 8px;
  border: 1px solid rgba(var(--v-theme-on-surface), 0.18);
  border-radius: 999px;
  background: rgb(var(--v-theme-surface));
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  color: var(--sh-text);
  cursor: pointer;
}
.si-chip:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}
.si-chip__initial {
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgb(var(--v-theme-primary));
  color: rgb(var(--v-theme-on-primary));
  font-size: 11px;
  font-weight: 700;
}
.si-chip__email {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.si-chip__change {
  flex: 0 0 auto;
  color: var(--sh-text-60);
}
</style>
